import React from "react"
import { Button, Checkbox, Table } from "react-bootstrap"
import FontAwesome from "react-fontawesome"
import AddCustomerFieldModal from "./AddCustomerFieldModal"
import PreviewCustomerInfo from "./PreviewCustomerInfo"

export default class CustomerInfoTable extends React.Component {

  state = {
    show: false,
    showInfo: false,
    item: {},
  }

  centerCenter = 'align-center v-center'

  centerClickable = `${ this.centerCenter } cursor-pointer`

  renderTh = (name, title) => <th className={ this.centerCenter } title={ title }><small>{ name }</small></th>

  renderTd = (item, content) => <td className={ this.centerClickable } 
    onClick={_ => this.showInfo(item) }>{ content }</td>

  showInfo = item => this.setState({ showInfo: true, item })

  removeCurrentItem = (removeCustomerInfo) => {
    if(removeCustomerInfo(this.state.item.name)) {
      this.closeShowInfo()
    }
  }

  closeShowInfo = () => this.setState({ showInfo: false })

  render() {

    const { customerInfos, removeCustomerInfo, running } = this.props,

    data = customerInfos.map((item, index) => <tr key={`customerInfo-${index}`} 
      title="Click to preview">
      { this.renderTd(item, item.name) }
      { this.renderTd(item, <small>{ item.type }</small>) }
      { this.renderTd(item, item.label) }
      { this.renderTd(item, <Checkbox checked={ item.mandatory } readOnly></Checkbox>) }
      { this.renderTd(item, <Checkbox checked={ item.unique } readOnly></Checkbox>) }
      <td className={ this.centerCenter }>
        <span className="red cursor-pointer" 
          onClick={() => removeCustomerInfo(item.name)}>
          <FontAwesome name="trash" title='Delete' />
        </span>
      </td>
    </tr>)

    return (
      <div>
        <Table striped bordered condensed hover responsive>
          <thead>
            <tr>
              { this.renderTh('ID') }
              { this.renderTh('TYPE') }
              { this.renderTh('LABEL') }
              { this.renderTh('REQUIRED', 'The field is mandatory?') }
              { this.renderTh('IS UNIQUE', 'Will the value be unique in the database?') }
              { this.renderTh('Action') }
            </tr>
          </thead>
          <tbody>
            { data }
            <tr>
              <td className={ `${this.centerCenter} p-10` } colSpan={7}>
                <Button bsStyle="default" title='Add a new customer field'
                  disabled={ running }
                  onClick={_ => this.setState({ show: true })}>
                  <FontAwesome name="plus" /> Add new field
                </Button>
              </td>
            </tr>
          </tbody>
        </Table>

        <AddCustomerFieldModal 
          show={ this.state.show } 
          close={() => this.setState({ show: false })}
          addInfo={ this.props.addInfo }
          infoExists={ this.props.infoExists }
        />

        <PreviewCustomerInfo 
          show={ this.state.showInfo } 
          close={() => this.closeShowInfo()}
          data={ this.state.item }
          remove={() => this.removeCurrentItem(removeCustomerInfo)}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings/Customers/CustomerInfoTable.js